var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.80005 20.9996C4.80005 19.09 5.55862 17.2587 6.90888 15.9084C8.25914 14.5582 10.0905 13.7996 12 13.7996C13.9096 13.7996 15.741 14.5582 17.0912 15.9084C18.4415 17.2587 19.2 19.09 19.2 20.9996H4.80005ZM12.9 15.6743V19.1996H17.0931C16.7714 18.2919 16.2131 17.4865 15.476 16.8668C14.7388 16.247 13.8496 15.8353 12.9 15.6743ZM11.1 19.1996V15.6743C10.1505 15.8353 9.26127 16.247 8.52411 16.8668C7.78696 17.4865 7.22867 18.2919 6.90695 19.1996H11.1ZM12 12.8996C9.01655 12.8996 6.60005 10.4831 6.60005 7.49961C6.60005 4.51611 9.01655 2.09961 12 2.09961C14.9835 2.09961 17.4 4.51611 17.4 7.49961C17.4 10.4831 14.9835 12.8996 12 12.8996ZM12 11.0996C13.989 11.0996 15.6 9.48861 15.6 7.49961C15.6 5.51061 13.989 3.89961 12 3.89961C10.011 3.89961 8.40005 5.51061 8.40005 7.49961C8.40005 9.48861 10.011 11.0996 12 11.0996Z",
    fill: "#2D9F75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.5a30452004c7f43bef7dc91051b3df1b.svg";
export { ForwardRef as ReactComponent };